import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'tachyons';
import App from './Containers/App';

ReactDOM.render(
  <App />,
  document.getElementById('root'));

reportWebVitals();
